import { ACTIVE } from '../classnames/design-system';
import { CHECKBOX_TOGGLE_CONTAINER } from '../classnames/checkbox-toggle';

export class SubscriptionCard {
  constructor(cards) {
    this.cards = cards;
  }

  setActiveCard = ({ dataset: { variantId, purchaseType }}) => {
    let activeCard;

    this.cards.forEach((card) => {
      if (card.dataset.variantId === variantId) {
        if (card.dataset.subscriptionState === purchaseType) {
          card.classList.remove(ACTIVE);
        } else {
          card.classList.add(ACTIVE);
          activeCard = card;
        }
      }
    });

    return activeCard;
  };

  handleClick = (e) => {
    e.preventDefault();

    this.setActiveCard(e.currentTarget);
  };

  initializeEventListeners = () => {
    [...document.querySelectorAll(CHECKBOX_TOGGLE_CONTAINER)].forEach((container) => {
      container.addEventListener('click', this.handleClick);
    });
  };
}
